export const ZIP_MAX_LENGTH = 10;
export const TEL_MAX_LENGTH = 20;

export const FIRST_NAME_MAX_LENGTH = 40;
export const LAST_NAME_MAX_LENGTH = 40;

export const PASSWORD_MAX_LENGTH = 64;

export const DEFAULT_MAX_LENGTH = 100;

export const ABOUT_MAX_LENGTH = 500;

export const MIN_YEARS_OF_PRACTICE = 1;
export const MAX_YEARS_OF_PRACTICE = 50;

export const MIN_APPOINTMENT_PRICE = 20;
export const MAX_APPOINTMENT_PRICE = 200;

export const MBite = 1024 * 1024;

export const MIN_FT_HEIGHT = 1;
export const MAX_FT_HEIGHT = 8;
export const MIN_IN_HEIGHT = 1;
export const MAX_IN_HEIGHT = 11;
export const MIN_WEIGHT = 5;
export const MAX_WEIGHT = 700;
export const MIN_WAIST = 10;
export const MAX_WAIST = 90;
export const MIN_HIPS = 10;
export const MAX_HIPS = 90;

export interface Validations {
  isPersonalInfoValid: boolean;
  isContactInfoValid: boolean;
  isQuestionnaireValid: boolean;
  isPersonaVerified: boolean;
  isStateDobValid: boolean;
  isSudReport: boolean;
  isSubstance: boolean;
  generalValidation: boolean;
}
